// 复姓
export default {
  "万俟": [["mò"], ["qí"]],
  "上官": [["shàng"], ["guān"]],
  "东方": [["dōng"], ["fāng"]],
  "东郭": [["dōng"], ["guō"]],
  "东门": [["dōng"], ["mén"]],
  "乐正": [["yuè"], ["zhèng"]],
  "亓官": [["qí"], ["guān"]],
  "仉督": [["zhǎng"], ["dū"]],
  "令狐": [["líng"], ["hú"]],
  "仲孙": [["zhòng"], ["sūn"]],
  "公冶": [["gōng"], ["yě"]],
  "公孙": [["gōng"], ["sūn"]],
  "公羊": [["gōng"], ["yáng"]],
  "公良": [["gōng"], ["liáng"]],
  "公西": [["gōng"], ["xī"]],
  "单于": [["chán"], ["yú"]],
  "南宫": [["nán"], ["gōng"]],
  "南门": [["nán"], ["mén"]],
  "司寇": [["sī"], ["kòu"]],
  "司徒": [["sī"], ["tú"]],
  "司空": [["sī"], ["kōng"]],
  "司马": [["sī"], ["mǎ"]],
  "呼延": [["hū"], ["yán"]],
  "壤驷": [["rǎng"], ["sì"]],
  "夏侯": [["xià"], ["hóu"]],
  "太叔": [["tài"], ["shū"]],
  "夹谷": [["jiá"], ["gǔ"]],
  "子车": [["zǐ"], ["jū"]],
  "宇文": [["yǔ"], ["wén"]],
  "宗政": [["zōng"], ["zhèng"]],
  "宰父": [["zǎi"], ["fǔ"]],
  "尉迟": [["yù"], ["chí"]],
  "左丘": [["zuǒ"], ["qiū"]],
  "巫马": [["wū"], ["mǎ"]],
  "慕容": [["mù"], ["róng"]],
  "拓跋": [["tuò"], ["bá"]],
  "梁丘": [["liáng"], ["qiū"]],
  "榖梁": [["gǔ"], ["liáng"]],
  "欧阳": [["ōu"], ["yáng"]],
  "段干": [["duàn"], ["gān"]],
  "淳于": [["chún"], ["yú"]],
  "漆雕": [["qī"], ["diāo"]],
  "澹台": [["tán"], ["tái"]],
  "濮阳": [["pú"], ["yáng"]],
  "申屠": [["shēn"], ["tú"]],
  "百里": [["bǎi"], ["lǐ"]],
  "皇甫": [["huáng"], ["pǔ"]],
  "端木": [["duān"], ["mù"]],
  "第五": [["dì"], ["wǔ"]],
  "羊舌": [["yáng"], ["shé"]],
  "西门": [["xī"], ["mén"]],
  "诸葛": [["zhū"], ["gě"]],
  "赫连": [["hè"], ["lián"]],
  "轩辕": [["xuān"], ["yuán"]],
  "钟离": [["zhōng"], ["lí"]],
  "长孙": [["zhǎng"], ["sūn"]],
  "闻人": [["wén"], ["rén"]],
  "闾丘": [["lǘ"], ["qiū"]],
  "颛孙": [["zhuān"], ["sūn"]],
  "鲜于": [["xiān"], ["yú"]],
} as Record<string, string[][]>;
